import { ITableField } from '@/shared/Tables/Table'
import { IAlarmSituation } from '../../alarmSituations.types.ts'
import AlarmSituationLevelTag from '@/pages/Processes/AlarmSituations/components/AlarmSituationLevelTag'

const alarmSituationsTableFields: ITableField<IAlarmSituation, keyof IAlarmSituation>[] = [
  {
    key: 'level',
    clientSideOrdering: true,
    width: '200px',
    header: 'Тип',
    getter: (it) => <AlarmSituationLevelTag level={it.level} />,
    sortGetter: (it) => it.level,
  },
  {
    key: 'name',
    clientSideOrdering: true,
    width: '300px',
    header: 'Наименование',
    getter: (it) => it.name,
    sortGetter: (it) => it.name,
  },
  {
    key: 'comment',
    clientSideOrdering: true,
    width: '500px',
    header: 'Комментарий',
    getter: (it) => it.comment,
    sortGetter: (it) => it.comment,
  },
]

export default alarmSituationsTableFields
